<template>
  <card>
    <div class="row">
      <div class="col-12 col-md-4">
        <selector
          v-model="season"
          :title="`Выберите учбеный сезон`"
          :prefix="'season'"
          :modal="`season`"
          :params="{}"
          :selectKey="`title`"
        />
      </div>
      <div class="col-12 col-md-4">
        <selector
          v-if="season"
          v-model="group"
          :title="`Выберите класс`"
          :prefix="'group'"
          :modal="`group`"
          :params="{}"
          :selectKey="`title`"
        />
      </div>
    </div>
    <part-list
      v-if="group"
      :season="season"
      :group="group"
      v-model="dataParams"
    />

    <AttendanceList
      v-if="dataParams && group"
      :group="group"
      :dataParams="dataParams"
    />
    <!-- {{ group }} -->
    <!-- результат -->
  </card>
</template>
<script>
import PartList from "@/components/Stats/PartList";
import AttendanceList from "@/components/Stats/AttendanceList";

export default {
  components: {
    PartList,
    AttendanceList,
  },
  created() {},
  methods: {},
  data() {
    return {
      season: null,
      dataParams: null,
      group: null,
    };
  },

  watch: {
    season: {
      handler: function (val) {
        this.group = null;
        this.dataParams = null;
      },
      deep: true,
      immediate: true,
    },
    group: {
      handler: function (val) {
        this.dataParams = null;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style>
</style>
